export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkAbout: "nav-link-about",
  linkProducts: "nav-link-products",
  linkIndustries: "nav-link-industries",
  linkContact: "nav-link-contact",
  ctaContact: "nav-cta-contact",
};

export const HERO = {
  section: "hero-section",
  ctaExplore: "hero-cta-explore",
  ctaInquire: "hero-cta-inquire",
};

export const PRODUCTS = {
  section: "products-section",
  item: (code) => `product-item-${code}`,
};

export const CONTACT = {
  section: "contact-section",
  form: "contact-form",
  name: "contact-input-name",
  company: "contact-input-company",
  email: "contact-input-email",
  phone: "contact-input-phone",
  interest: "contact-select-interest",
  message: "contact-input-message",
  submit: "contact-submit-btn",
  success: "contact-success-msg",
};
